import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DependencyAudiencesTable } from '../DependencyAudiencesTable';
import { useGetDataSourceDependenciesQuery } from '@/services/dataSources';
import { DataSource } from '@/models/dataSource';

import AnnotationIcon from '@/assets/icons/annotation-info.svg?react';
import { useWorkspace } from '@/features/workspaces/hooks';

type DataSourceDependencyAudiencesProps = {
  dataSource: DataSource;
};

export const DataSourceDependencyAudiences: FC<DataSourceDependencyAudiencesProps> = ({ dataSource }) => {
  const { t } = useTranslation('ALL');
  const workspace = useWorkspace();

  const { data: dependencies, isLoading: isDependenciesLoading } = useGetDataSourceDependenciesQuery({
    workspaceId: workspace.id,
    dataSourceId: dataSource.id,
  });

  return (
    <div className='flex flex-col gap-3'>
      <div className='flex justify-between pl-5 text-sm font-normal text-tertiary-600'>
        <p>
          <Trans
            i18nKey='data_source_details:overview.audiences_title'
            values={{
              dataSource: dataSource.name,
            }}
            components={{
              strongBlue: <span className='font-semibold text-brand-600' />,
            }}
          />
        </p>
        {dependencies?.audiences?.length > 0 && (
          <p className='flex gap-1'>
            <AnnotationIcon className='size-5' />
            {t('data_sources.cannotDeleteDataSource')}
          </p>
        )}
      </div>

      <DependencyAudiencesTable audiences={dependencies?.audiences} isLoading={isDependenciesLoading} />
    </div>
  );
};
